/**
 * Bounded retries for an already-exchanged authentication token during explicit API maintenance.
 * Provider authorization codes are never replayed by this helper.
 *
 * @module apps/web/src/lib/authMaintenance
 */

/** Retain the already-exchanged issuer token in the caller during a brief API cutover.
 * Only an explicit 503 is retryable; never replay provider authorization codes.
 */
export async function retryAuthMaintenance<T extends { /** HTTP status used to retry temporary 503 authentication-maintenance responses only. */ status?: number }>(
  operation: () => Promise<T>,
  pause: () => Promise<void> = () => new Promise(resolve => setTimeout(resolve, 2000))
): Promise<T> {
  for (let attempt = 0; ; attempt++) {
    const result = await operation();
    if (result.status !== 503 || attempt >= 149) return result;
    await pause();
  }
}
